// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPass_container__5fYul","contentWrapper":"ResetPass_contentWrapper__XjQGK","signUpMessage":"ResetPass_signUpMessage___Mp13"};